import { createServerFn } from "@tanstack/react-start";
import { requireSupabaseAuth } from "@/integrations/supabase/auth-middleware";
import { assertAdmin } from "@/lib/admin-guard.server";
import {
  EXPERT_VISIBILITY_DEFAULT,
  isExpertVisibility,
  type ExpertVisibility,
} from "./expert-visibility.shared";

export { EXPERT_VISIBILITY_DEFAULT, isExpertVisibility };
export type { ExpertVisibility };


/** Läser inställningen. Publik – innehåller ingen känslig information. */
export const getExpertVisibility = createServerFn({ method: "GET" }).handler(
  async (): Promise<{ mode: ExpertVisibility }> => {
    try {
      const { odb } = await import("./orders.server");
      const { data } = await odb()
        .from("app_settings")
        .select("expert_visibility")
        .eq("id", "global")
        .maybeSingle();
      const mode = (data as { expert_visibility?: unknown } | null)?.expert_visibility;
      return { mode: isExpertVisibility(mode) ? mode : EXPERT_VISIBILITY_DEFAULT };
    } catch {
      return { mode: EXPERT_VISIBILITY_DEFAULT };
    }
  },
);

export const setExpertVisibility = createServerFn({ method: "POST" })
  .inputValidator((input: unknown) => {
    const mode = (input as { mode?: unknown })?.mode;
    if (!isExpertVisibility(mode)) throw new Error("Ogiltigt värde.");
    return { mode };
  })
  .middleware([requireSupabaseAuth])
  .handler(async ({ data, context }) => {
    await assertAdmin(context as never);
    const { odb } = await import("./orders.server");
    await odb()
      .from("app_settings")
      .upsert({ id: "global", expert_visibility: data.mode }, { onConflict: "id" });
    return { ok: true, mode: data.mode };
  });

// Serverkontrollen (assertExpertAllowed) bor i expert-visibility.server.ts.

